import { Navigate } from 'react-router-dom'
import useAccountStore from '@/account/accountStore'
import { usePrimaryAccount } from '@/account/usePrimaryAccount'
import { isPrimaryAdviserContext } from '@/common/navigation/accountRoutes'
import { APP_ROUTES } from '@/common/constants'

function RequirePrimaryAdviserContext({ children }: { children: any }) {
    const primaryAccount = usePrimaryAccount()
    const activeAccountId = useAccountStore((s) => s.activeAccountId)

    if (isPrimaryAdviserContext({ primaryAccount, activeAccountId })) {
        return <>{children}</>
    }

    return <Navigate to={APP_ROUTES.DASHBOARD} replace />
}

export default RequirePrimaryAdviserContext
